export default "__VITE_ASSET__CyDmMEMe__"